import { render, staticRenderFns } from "./Museum.vue?vue&type=template&id=1d79a286&scoped=true&"
import script from "./Museum.vue?vue&type=script&lang=ts&"
export * from "./Museum.vue?vue&type=script&lang=ts&"
import style0 from "./Museum.vue?vue&type=style&index=0&id=1d79a286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79a286",
  null
  
)

export default component.exports